import React, { useEffect, useState } from "react";
import { partners } from "../../constants";
import styles from "../../style";

const Partner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // animate in on mount (simple match with HeroBanner's pattern)
    setIsVisible(true);
  }, []);

  return (
    <section
      id="partners"
      className={`relative w-full overflow-hidden bg-gradient-to-b from-white to-gray-50 ${styles.flexCenter} flex-col py-20`}
    >
      {/* Ambient gradient blobs (same style language as HeroBanner) */}
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -left-40 -top-40 h-[420px] w-[420px] rounded-full bg-blue-400/15 blur-3xl animate-pulse" />
        <div className="absolute -right-40 top-40 h-[460px] w-[460px] rounded-full bg-emerald-400/15 blur-3xl animate-pulse delay-700" />
        <div className="absolute left-1/2 -bottom-48 h-[500px] w-[500px] -translate-x-1/2 rounded-full bg-purple-400/10 blur-3xl animate-pulse delay-1000" />
      </div>

      {/* Content container */}
      <div className="relative z-10 container mx-auto px-4 text-center">
        {/* Badge */}
        <div
          className={`mb-6 inline-flex items-center gap-2 rounded-full border border-gray-200 bg-gradient-to-r from-blue-50 to-emerald-50 px-3 py-1.5 text-xs font-medium text-gray-700 transition-all duration-1000 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-2"
          }`}
        >
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-75"></span>
            <span className="relative inline-flex h-2 w-2 rounded-full bg-emerald-500"></span>
          </span>
          Trusted by agencies & partners
        </div>

        {/* Heading */}
        <h2
          className={`mb-3 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl transition-all duration-1000 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2"
          }`}
        >
          <span className="bg-gradient-to-r from-blue-600 via-cyan-600 to-emerald-600 bg-clip-text text-transparent">
            Our Partners & Sponsors
          </span>
        </h2>

        {/* Subhead */}
        <p
          className={`mx-auto mb-10 max-w-2xl text-gray-600 transition-all duration-1000 delay-100 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2"
          }`}
        >
          Collaborating to digitize streets, improve mobility, and deliver
          measurable outcomes.
        </p>

        {/* Logo grid */}
        <div
          className={`mx-auto grid w-full max-w-6xl grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 transition-all duration-1000 delay-200 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2"
          }`}
        >
          {partners.map((client) => {
            const hasLink = !!client.url;
            const card = (
              <div
                key={client.id}
                className="group relative flex items-center justify-center rounded-2xl border border-gray-200/70 bg-white/70 backdrop-blur-sm shadow-sm hover:shadow-lg transition-all hover:-translate-y-0.5"
              >
                {/* soft highlight on hover */}
                <div className="pointer-events-none absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity bg-gradient-to-br from-blue-50/60 to-emerald-50/60" />

                <img
                  src={client.logo}
                  alt={client.name ? `${client.name} logo` : "partner logo"}
                  loading="lazy"
                  className="m-6 h-12 w-auto object-contain grayscale opacity-80 transition-all duration-300 group-hover:grayscale-0 group-hover:opacity-100 sm:h-14"
                  sizes="(max-width: 640px) 120px, (max-width: 1024px) 160px, 192px"
                />
              </div>
            );

            return hasLink ? (
              <a
                key={client.id}
                href={client.url}
                target="_blank"
                rel="noopener noreferrer"
                className="focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500 rounded-2xl"
                aria-label={client.name ? `Visit ${client.name}` : "Visit partner"}
              >
                {card}
              </a>
            ) : (
              card
            );
          })}
        </div>

        
      </div>
    </section>
  );
};

export default Partner;
